import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    theme:'red'
  },
  getters:{
    getTheme: state => {
      return state.theme
    } 
  },
  mutations: {
    setTheme: (state, theme) => {
      state.theme = theme
    }
  },
  actions: {
  },
  modules: {
  }
})
